import { ConsultationBand, PublicHero, PublicShell } from "@/components/PublicShell"
import { PublicMeta } from "@/components/public/PublicMeta"

const DESCRIPTION =
  "The terms on which SOH GD Wines supplies bespoke-label South African wine, including ordering, label approval and delivery in the UK."

export default function Terms() {
  return (
    <PublicShell>
      <PublicMeta title="Terms & Conditions" description={DESCRIPTION} />
      <PublicHero
        eyebrow="Legal"
        title="Terms &amp; Conditions"
        lede="The terms on which we supply bespoke-label wine, from order to delivery."
      />

      <section className="band band-black">
        <div className="shell">
          <div className="body-content max-w-[70ch]">
            <p>
              <strong>Draft for Duncan's review.</strong> This page is a standard template for a
              UK bespoke-label wine supplier and has not yet been signed off. It must be reviewed
              and approved before the site goes live.
            </p>

            <p>Last updated: 25 September 2026.</p>

            <h2>About us</h2>
            <p>
              SOH GD Wines ("we", "us", "our") supplies premium South African wine with bespoke,
              custom-designed labels to customers in the United Kingdom. These terms apply to
              every enquiry, quote and order placed through this website or directly with us.
            </p>

            <h2>How ordering works</h2>
            <p>
              This site does not take online payment. Every order begins as an enquiry: you tell
              us the wines, quantities, event details and label idea you have in mind, and we
              respond with a written quote. An order is only confirmed once you have accepted that
              quote and approved your label design in writing.
            </p>
            <p>
              Orders are built from a 100-bottle mixable minimum — for example 50 red and 50
              white, or any combination across our range. There is no requirement to order in
              multiples of six or twelve.
            </p>

            <h2>Label design and approval</h2>
            <p>
              Any artwork, logo or photograph you supply is used to produce a bespoke label proof.
              Nothing is sent to print until you have reviewed and approved that proof in writing.
              We reserve the right to decline artwork that infringes a third party's copyright or
              trademark, or that is unsuitable for reproduction, and will discuss an alternative
              with you.
            </p>
            <p>
              A mock-up produced through this site is illustrative and always subject to graphic
              design approval — the finished label may differ slightly from the on-screen preview
              to be reproducible at print quality.
            </p>

            <h2>Pricing and quotes</h2>
            <p>
              All prices are quoted in pounds sterling and are confirmed in writing before an order
              is placed. A quote covers the wine, the bespoke label and, where agreed, delivery.
              Prices may vary between wines and are not published as a live online price list.
            </p>

            <h2>Delivery</h2>
            <p>
              We deliver throughout the United Kingdom. Delivery timeframes and costs are
              confirmed as part of your quote and depend on your order size, label complexity and
              the time of year — please get in touch as early as possible for date-sensitive
              events such as weddings.
            </p>

            <h2>Cancellations</h2>
            <p>
              Because every order is produced to your specification, an order cannot be cancelled
              once you have approved the final label proof and production has begun. Before that
              point, you may cancel or amend your order by contacting us directly.
            </p>

            <h2>Age restriction</h2>
            <p>
              Our products contain alcohol. By placing an enquiry or order through this site you
              confirm that you are 18 years of age or over. We reserve the right to request proof
              of age and to refuse an order where this cannot be confirmed.
            </p>

            <h2>Liability</h2>
            <p>
              We take reasonable care in producing every label and fulfilling every order. Nothing
              in these terms limits our liability for matters that cannot be limited under English
              law, such as fraud or death or personal injury caused by our negligence.
            </p>

            <h2>Governing law</h2>
            <p>
              These terms are governed by the laws of England and Wales, and any dispute will be
              subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>

            <h2>Contact us</h2>
            <p>
              Questions about these terms, or about a specific order, can be sent through our{" "}
              <a href="/contact">Contact</a> page.
            </p>
          </div>
        </div>
      </section>

      <ConsultationBand />
    </PublicShell>
  )
}
